<template>
  <div class="edit_main">
    <Form
      class="fx_1"
      ref="addModel"
      :model="addModel"
      :rules="ruleValidate"
      :label-width="120"
      inline
    >
      <FormItem label="模板名称" prop="TemplateName">
        <Input class="w-250" v-model="addModel.TemplateName"></Input>
      </FormItem>

      <FormItem label="产品代码" prop="ProductCode">
        <Select class="w-250" v-model="addModel.ProductCode" clearable>
          <Option
            v-for="(item, index) in ProductCodeSelect"
            :value="item.dictionaryValue"
            :key="index"
            >{{ item.dictionaryValue }}</Option
          >
        </Select>
      </FormItem>

      <FormItem label="图片数量" prop="ImageNum">
        <Input type="number" class="w-250" v-model="addModel.ImageNum"></Input>
      </FormItem>

      <FormItem label="检查类型" prop="ExamType">
        <Select class="w-250" v-model="addModel.ExamType" clearable multiple>
          <Option
            v-for="(item, index) in ExamTypeSelect"
            :value="item.dictionaryValue"
            :key="index"
            >{{ item.dictionaryValue }}</Option
          >
        </Select>
      </FormItem>

      <FormItem label="状态" prop="ISActived">
        <RadioGroup v-model="addModel.ISActived">
          <Radio label="1">启用</Radio>
          <Radio label="0">禁用</Radio>
        </RadioGroup>
      </FormItem>

      <!-- <div> -->
        <FormItem label="所属机构" prop="OrganName">
          <Button type="primary" @click="treeModel = true">选择所属机构</Button>
          <span class="ml-5">{{ addModel.OrganName }}</span>
          <Input v-show="false" v-model="addModel.OrganName"></Input>
        </FormItem>
      <!-- </div> -->

      <!-- <div> -->
        <FormItem label="模板文件" prop="TemplateFileName">
          <Upload
            :format="['frx']"
            :action="uploadUrl"
            :on-format-error="handleFormatError"
            :before-upload="handleBeforeUpload"
            :on-success="handleSuccess"
            :on-error="handleError"
            :on-remove="handleRemove"
          >
            <Button icon="ios-cloud-upload-outline">选择文件</Button>
            <span style="margin-left: 10px; color: red"
              >最多一个文件，文件类型：frx</span
            >
          </Upload>
        </FormItem>
      <!-- </div> -->
    </Form>

    <Divider></Divider>

    <div class="text-center">
      <Button @click="returnBack" class="mr-5">取 消</Button>
      <Button type="success" @click="handleSubmit('addModel')"
        >确 定</Button
      >
    </div>

    <Modal v-model="treeModel" title="选择上级机构">
      <organTree @selectTreeData="selectTreeData"></organTree>
    </Modal>
  </div>
</template>
<script>
import organTree from "../organ/organTree.vue";

export default {
  components: { organTree },
  data: function () {
    const validateNum = (rule, value, callback) => {
      if (!/(^[0-9]\d*$)/.test(value)) {
        callback(new Error("请输入正整数"));
      } else {
        callback();
      }
    };

    return {
      uploadUrl: "",
      organTypeSelect: [],
      treeModel: false,
      addModel: {
        TemplateName: null,
        ImageNum: 0,
        ExamType: null,
        OrganName: null,
        ISActived: "1",
        OrganID: null,
        ProductCode: null,
        TemplateFileName: null,
        TemplateFileUrl: null,
      },
      uploadList: [],
      ruleValidate: {
        TemplateName: [
          {
            required: true,
            message: "不能为空",
          },
        ],
        ProductCode: [
          {
            required: true,
            message: "不能为空",
          },
        ],
        OrganName: [
          {
            required: true,
            message: "不能为空",
          },
        ],
        TemplateFileName: [
          {
            required: true,
            message: "不能为空",
          },
        ],
        ImageNum: [{ validator: validateNum, trigger: "blur" }],
      },
      ProductCodeSelect: [],
      ExamTypeSelect: [],
    };
  },

  activated: function () {
    this.uploadUrl =
      localStorage.getItem("baseURL") + "/MediaCenter/PostFile";

    this.$common.getDictionaryByCode("CP00").then((data) => {
      this.ProductCodeSelect = data;
    });
    this.$common.getDictionaryByCode("JCLX").then((data) => {
      this.ExamTypeSelect = data;
    });
  },

  methods: {
    returnBack: function () {
      this.$router.push("printTemplate");
    },

    handleSubmit: function (from) {
      this.$refs[from].validate((valid) => {
        if (valid) {
          if (this.addModel.ProductCode == "RIS" && !this.addModel.ExamType) {
            this.$Message.error("请选择检查类型");
            return false;
          }

          if (this.addModel.ProductCode != "RIS" && !this.addModel.ImageNum) {
            this.$Message.error("请输入图片数量");
            return false;
          }
          if (this.addModel.ExamType)
            this.addModel.ExamType = this.addModel.ExamType.join();
          this.$api.post("printTemplate/create", this.addModel).then((rsp) => {
            if (rsp != false) {
              this.$Message.success("添加成功");
              this.$refs["addModel"].resetFields();
              this.returnBack();
            }
          });
        }
      });
    },

    selectTreeData: function (data) {
      this.addModel.OrganID = data[0].organID;
      this.addModel.OrganName = data[0].title;
    },

    handleSuccess: function (res, file) {
      this.addModel.TemplateFileName = res.data.fileNames;
      this.addModel.TemplateFileUrl = res.data.fileUrls;
    },

    handleFormatError: function (file) {
      this.$Message.error("文件类型不正确");
    },

    handleBeforeUpload: function () {
      if (this.addModel.TemplateFileName) {
        this.$Message.error("最多上传一个文件");
        return false;
      }
    },

    handleError: function () {
      this.$Message.error("文件上传失败");
    },

    handleRemove: function (file, fileList) {
      this.addModel.TemplateFileName = null;
      this.addModel.TemplateFileUrl = null;
    },
  },
};
</script>
<style scoped>
</style>